import { app, Component, payload, ojs, state, v } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import {
    pageInfo,
    redirect,
    either,
    scrollToTop,
    store,
    getStore,
} from "../../helpers";
import { api, gc, dc } from "../../declarations";
import { Preferences } from "@capacitor/preferences";
import { $e } from "../../ojs.events";

const h = app("h");

export default class SelectCompany extends Component {
    loading = state(false);

    render() {
        pageInfo("Select Company");
        scrollToTop();

        if (dc.deliveryCompanies.value.length === 0) {
            this.loading.value = true;
            this.fetchCompanies();
        } else {
            this.fetchCompanies(true);
        }

        return h.div(
            { class: " py-5 mb-5" },
            h.div(
                { class: "container py-5" },
                h.div(
                    { class: "text-center mb-5" },
                    h.h1({ class: "display-5 fw-bold mb-3" }, "Welcome back!"),
                    h.p(
                        { class: "lead text-muted" },
                        "Which company are we operating under today?",
                    ),
                ),

                v(this.loading, (loading) => {
                    if (loading.value)
                        return h.div(
                            { class: "text-center py-5" },
                            h.Spinner(),
                        );

                    return v(dc.deliveryCompanies, (companies) => {
                        if (!companies.value || companies.value.length === 0) {
                            return h.div(
                                {
                                    class: "text-center py-5 px-4 bg-white shadow-sm border border-1 border-dashed mx-auto",
                                    style: "max-width: 500px; border-radius: 24px;",
                                },
                                h.div(
                                    { class: "mb-3 text-warning" },
                                    h.i({ class: "bi bi-exclamation-triangle-fill", style: "font-size: 3rem;" })
                                ),
                                h.h4({ class: "fw-bold mb-2 text-dark" }, "No Company to Show"),
                                h.p(
                                    { class: "text-muted mb-0 lh-base" },
                                    "Please contact Carata to add you to a delivery company."
                                )
                            );
                        }

                        return h.div(
                            { class: "row g-4 justify-content-center" },
                            ...companies.value.map((company) =>
                                this.renderCompanyCard(company),
                            )
                        );
                    });
                }),
            ),
        );
    }

    renderCompanyCard(company) {
        const initials = company.name
            .split(" ")
            .map((n) => n[0])
            .join("")
            .substring(0, 2)
            .toUpperCase();

        return h.div(
            { class: "col-12 col-md-6 col-lg-4" },
            h.div(
                {
                    class: "card border-0 shadow-sm h-100 cursor-pointer overflow-hidden transition-all hover-translate-y",
                    style: "border-radius: 24px;",
                    onclick: this.method("selectCompany", [company]),
                },
                h.div(
                    { class: "card-body p-4 p-lg-5" },
                    h.div(
                        { class: "d-flex align-items-center gap-4" },
                        h.div(
                            {
                                class: "rounded-4 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0",
                                style: "width: 80px; height: 80px; background: linear-gradient(135deg, #973e87 0%, #6f2a63 100%); color: white; font-size: 1.75rem; font-weight: 700;",
                            },
                            initials,
                        ),
                        h.div(
                            { class: "flex-fill overflow-hidden" },
                            h.h4(
                                { class: "fw-bold mb-1 text-truncate" },
                                company.name,
                            ),
                            h.div(
                                { class: "d-flex align-items-center gap-2" },
                                h.span(
                                    {
                                        class: "badge bg-primary-subtle text-primary rounded-pill px-3",
                                    },
                                    `@${company.handle || "id-" + company.id}`,
                                ),
                            ),
                        ),
                    ),
                    h.hr({ class: "my-4 opacity-5" }),
                    h.div(
                        {
                            class: "d-flex justify-content-between align-items-center",
                        },
                        h.div(
                            {},
                            h.div(
                                {
                                    class: "text-muted small text-uppercase fw-bold letter-spacing-1",
                                },
                                "Status",
                            ),
                            h.div(
                                {
                                    class: "fw-bold text-success d-flex align-items-center gap-1",
                                },
                                h.span({
                                    class: "circle bg-success",
                                    style: "--size: 8px;",
                                }),
                                "Active",
                            ),
                        ),
                        h.div(
                            { class: "text-end" },
                            h.div(
                                {
                                    class: "text-muted small text-uppercase fw-bold letter-spacing-1",
                                },
                                "Role",
                            ),
                            h.div({ class: "fw-bold" }, "Rider"),
                        ),
                    ),
                ),
                h.div(
                    {
                        class: "px-4 py-3 border-top d-flex justify-content-between align-items-center",
                    },
                    h.span(
                        { class: "small fw-bold text-muted" },
                        "Switch to this company",
                    ),
                    h.i({
                        class: "bi bi-arrow-right-circle-fill fs-4 text-primary",
                    }),
                ),
            ),
        );
    }

    async fetchCompanies(background = false) {
        if (!background) this.loading.value = true;
        try {
            const res = await api.get("deliverer/configs");

            if (res && res.data && res.data.companies) {
                dc.deliveryCompanies.value = res.data.companies;
                await Preferences.set({
                    key: "delivery_companies",
                    value: JSON.stringify(res.data.companies),
                });
            }
            else if (res && !res.data.isLoggedIn) {
                app('broker').send($e.system.needs.configReload);
                app('router').to('home');
            }
        } catch (e) {
            console.error(e);
        } finally {
            if (!background) this.loading.value = false;
        }
    }

    async selectCompany(company) {
        let previousCompany =
            (await getStore("current_delivery_company")) || window.currentCompany;

        window.currentCompany = company;
        window.currentDeliveryCompany = company;
        await store("current_delivery_company", company);
        app("inform")(`Switched to ${company.name}`, "success");

        app("broker").send(
            $e.company.has.changed,
            payload({
                previous: previousCompany,
                current: company,
            }),
        );

        redirect().to("home");
    }
}
